<div class="advertisement_details">
    <div class="custom_container">
                        
        <!-- start description -->
        <ng-container *ngIf="AdvertisementData?.description">
            <div [ngClass]="{'description_collapsed': IsDescriptionCollapsed}" class="wrap_description margin_bottom_5">
                <h4 class="font_22 font_600 main_color_4th">وصف العقار</h4>
                <p #description class="description font_22 font_400 color_gray mb-0" [innerHTML]="AdvertisementData?.description"></p>
                <ng-container *ngIf="isDescriptionLineLimited">
                    <span 
                        (click)="ToggleDescriptionCollapse()"
                        class="read_more_description effect float-end font_20 font_600 pointer d-flex align-items-center gap-3"
                    >
                        {{IsDescriptionCollapsed ? 'لقراءة اقل ' : 'لقراءة المزيد '}}
                        <i 
                            [ngClass]="[IsDescriptionCollapsed ? 'fa-arrow-up' : 'fa-arrow-down']"
                            class="fa-solid fa-sm border_r_full d-flex align-items-center justify-content-center">
                        </i>
                    </span>
                    <div class="clearfix"></div>
                </ng-container>
            </div>
        </ng-container>
        <!-- end description -->
    
        <!-- start app-advertisement-unit -->
        <ng-container *ngIf="IsNormal">
            <ul id="wrap_unit_details" class="linst_none wrap_unit_details border_radius_8 padding_x_8 padding_y_5">
                <ng-container *ngIf="AdvertisementData?.unitNumber">
                    <li class="d-flex flex-wrap gap-3 align-items-center justify-content-between font_18 text-black padding_y_5">
                        <span class=" font_600">رقم الوحدة</span>
                        <span class="font_18 font_700">{{AdvertisementData?.unitNumber}}</span>
                    </li>
                </ng-container>
                <!-- <ng-container *ngIf="cityAndAreaNames">
                    <li class="d-flex flex-wrap gap-3 align-items-center justify-content-between font_18 text-black padding_y_5">
                        <span class=" font_600">المدينة و الحي</span>
                        <span class="font_18 font_700">{{cityAndAreaNames}}</span>
                    </li>
                </ng-container> -->
                <ng-container *ngIf="getPropertyDetails('floorNumber')">
                    <li class="d-flex flex-wrap gap-3 align-items-center justify-content-between font_18 text-black padding_y_5">
                        <span class=" font_600">الدور</span>
                        <span class="font_18 font_700">{{getPropertyDetails('floorNumber').value.toString()}}</span>
                    </li>
                </ng-container>
                <ng-container>
                    <li class="d-flex flex-wrap gap-3 align-items-center justify-content-between font_18 text-black padding_y_5">
                        <span class=" font_600">المساحة</span>
                        <span class="font_18 font_700">{{handlerSize}} متر</span>
                    </li>
                </ng-container>
                <ng-container *ngIf="RegaAdvertisementData?.numberOfRooms || getPropertyDetails('bedrooms')">
                    <li class="d-flex flex-wrap gap-3 align-items-center justify-content-between font_18 text-black padding_y_5">
                        <span class=" font_600">عدد الغرف</span>
                        <span class="font_18 font_700">{{RegaAdvertisementData?.numberOfRooms || getPropertyDetails('bedrooms').value.toString()}}</span>
                    </li>
                </ng-container>
    
                <!-- start MoreUnitDetails -->
                <ng-container *ngIf="IsUnitDetailsCollapsed == false">
                    <li (click)="UnitDetailsToggleCollapse()" class="more_unit_details d-flex align-items-center justify-content-center padding_y_5">
                        <span class="float-end font_16 font_600 effect pointer d-flex align-items-center gap-2">
                            المزيد
                            <i class="fa-solid fa-arrow-down fa-sm icon_32 border border-2 border_r_full d-flex align-items-center justify-content-center"></i>
                        </span>                            
                    </li>
                </ng-container>
                <ng-container *ngIf="IsUnitDetailsCollapsed">
                    <ng-container *ngIf="AdvertisementData?.title">
                        <li class="d-flex flex-wrap gap-3 align-items-center justify-content-between font_18 text-black padding_y_5">
                            <span class=" font_600">عنوان الأعلان</span>
                            <span class="font_18 font_700">{{AdvertisementData?.title}}</span>
                        </li>
                    </ng-container>
    
                    <!-- start contractType -->
                    <ng-container>
                        <li class="d-flex flex-wrap gap-3 align-items-center justify-content-between font_18 text-black padding_y_5">
                            <span class=" font_600">نوع التعاقد</span>
                            <div class="d-flex flex-column gap-2 align-items-center">
                                <span class="font_18 font_700">
                                    {{AdvertisementData?.contractType | contractType}}
                                </span>
                            </div>
                        </li>
                    </ng-container>  
                    <!-- start contractType -->
    
                    <ng-container *ngIf="AdvertisementData?.address">
                        <li class="d-flex flex-wrap gap-3 align-items-center justify-content-between font_18 text-black padding_y_5">
                            <span class=" font_600">العنوان</span>
                            <span class="font_18 font_700">{{AdvertisementData?.address}}</span>
                        </li>
                    </ng-container>
                    <ng-container *ngIf="AdvertisementData?.streetName">
                        <li class="d-flex flex-wrap gap-3 align-items-center justify-content-between font_18 text-black padding_y_5">
                            <span class=" font_600">اسم الشارع</span>
                            <span class="font_18 font_700">{{AdvertisementData?.streetName}}</span>
                        </li>
                    </ng-container>                        
                    <ng-container *ngIf="AdvertisementData?.floors">
                        <li class="d-flex flex-wrap gap-3 align-items-center justify-content-between font_18 text-black padding_y_5">
                            <span class=" font_600">عدد الطوابق</span>
                            <span class="font_18 font_700">{{AdvertisementData?.floors | number }}</span>
                        </li>
                    </ng-container>
    
                    <!-- start Deposit -->
                    <ng-container *ngIf="AdvertisementData?.deposit && AdvertisementData?.hasDeposit && IsAvailable">
                        <li class="d-flex flex-wrap gap-3 align-items-center justify-content-between font_18 text-black padding_y_5">
                            <span class=" font_600">قيمة العربون</span>
                            <div class="d-flex flex-column gap-2 align-items-center">
                                <ng-container *ngIf="AdvertisementData?.depositPaidUser == null">
                                    <span class="font_18 font_700">{{AdvertisementData?.deposit | number }} ريال</span>
                                </ng-container>
                                <ng-container *ngIf="IsOwnerHasMarketPlace  && AdvertisementData?.depositPaidUser == null && IsOwner == false">
                                    <span
                                        (click)="DepositPay()"
                                        class="hasDeposit d-inline-block margin_start font_12 font_700 border_r color_white pointer effect deposit_pay padding_x_6 padding_y_2">
                                        ادفع الأن
                                    </span>
                                </ng-container>
                                <ng-container *ngIf="AdvertisementData?.depositPaidUser != null">
                                    <span class="d-inline-block font_12 font_700 margin_start border_r color_white main_color_bg padding_x_3 padding_y_2">تم دفع العربون</span>
                                </ng-container>
                            </div>
                        </li>
                    </ng-container> 
                    <!-- end Deposit -->
    
                    <ng-container *ngIf="AdvertisementData?.theAverage">
                        <li class="d-flex flex-wrap gap-3 align-items-center justify-content-between font_18 text-black padding_y_5">
                            <span class=" font_600">متوسط الأسعار</span>
                            <span class="font_18 font_700">{{AdvertisementData?.theAverage | number }} ريال</span>
                        </li>
                    </ng-container>
                    <ng-container *ngIf="AdvertisementData?.totalPrice">
                        <li class="d-flex flex-wrap gap-3 align-items-center justify-content-between font_18 text-black padding_y_5">
                            <span class=" font_600">اجمالي السعر</span>
                            <span class="font_18 font_700">{{AdvertisementData?.totalPrice | number }}</span>
                        </li>
                    </ng-container>
                    <ng-container *ngIf="AdvertisementData?.totalViews">
                        <li class="d-flex flex-wrap gap-3 align-items-center justify-content-between font_18 text-black padding_y_5">
                            <span class=" font_600">عدد المشاهدات الكلي</span>
                            <span class="font_18 font_700">{{AdvertisementData?.totalViews | shortNumber}}</span>
                        </li>
                    </ng-container>                        
                </ng-container>
                <!-- end MoreUnitDetails -->
    
                <li class="d-flex align-items-center justify-content-center main_color padding_y_5">
                    <h4 class="font_44 font_900 mb-0">
                        <ng-container *ngIf="handlerPrice != null; else priceIsNull">
                            {{(AdvertisementData | PriceHandler)?.toString}}
                            <span class="font_24 font_400">ريال</span>
                        </ng-container>
                        <ng-template #priceIsNull>
                            لايوجد سعر محدد
                        </ng-template>
                    </h4>
                </li>
            </ul>
        </ng-container>
    
    </div>
    <!-- ebd app-advertisement-unit -->

    <div class="custom_container">
        <hr class="margin_top_10 mb-0"/>  
    </div>

    <!-- start app-advertisement-details-slides -->
    <app-advertisement-details-slides [data]="AdvertisementData" />
    <!-- end app-advertisement-details-slides -->

    <!-- start advertisement units -->
    <ng-container *ngIf="isShowAdvertisementUnits">
        <app-advertisement-units [advertisementData]="AdvertisementData" classList="margin_y_7" />
    </ng-container>
    <!-- end advertisement units -->

    <!-- start advertisement-plan-zones -->
    <ng-container *ngIf="IsPlaning && AdvertisementData?.zones?.length > 0">
        <app-advertisement-plan-zones classList="margin_y_7" [advertisementData]="AdvertisementData" />
    </ng-container>
    <!-- end advertisement-plan-zones -->
     
    <!-- start advertisement-extra-details -->
    <div class="custom_container">
        <app-advertisement-extra-details [advertisementData]="AdvertisementData" [regaAdvertisementData]="RegaAdvertisementData" />
    </div>
    <!-- end advertisement-extra-details -->

    <!-- start advertisement-map-details -->
    <app-advertisement-map-details [advertisementData]="AdvertisementData" [regaAdvertisementData]="RegaAdvertisementData" />
    <!-- end advertisement-map-details -->

    <!-- // start bundled_ads -->
    <div 
        class="bundled_ads" 
        *ngIf="(AdvertisementData?.zones == null && AdvertisementData?.lands?.length > 0) || AdvertisementData?.villas?.length > 0"
    >
        <div class="custom_container">
            <div class="wrap">
                <ul class="list_none sub_ads_status text-center mb-3">
                    <li>مباع</li>
                    <li>متاح</li>
                    <li>محجوز</li>
                </ul>               

                <!-- // lands -->
                <ng-container *ngIf="AdvertisementData?.lands?.length > 0">

                    <h6 class="text-center mb-4 main_color label_lg_bold">
                        اجمالي عدد ارضي المخطط
                        <span class="color_black"> ( {{AdvertisementData?.lands?.length}} ) </span>
                    </h6>

                    <ul class="list_none tabs text-center" >
                        <ng-container *ngFor="let land of AdvertisementData?.lands">
                            <li 
                                [routerLink]="['../', land?.id]"
                                [ngClass]="{
                                    'sold': land?.status == STATUS_TYPE.COM,
                                    'booking': land?.status == STATUS_TYPE.booking,
                                    'available': land?.status == STATUS_TYPE.N || land?.status == STATUS_TYPE.Started || land?.status == STATUS_TYPE.PR
                                }"
                                class="d-inline-flex align-items-center justify-content-center border_r label_lg_normal pointer text-center"
                            >
                                <span>رقم الارض</span>
                                ( {{land?.unitNumber || land?.id}} )
                            </li>
                        </ng-container>
                    </ul>
                </ng-container>

                <!-- // villas -->
                <ng-container *ngIf="AdvertisementData?.villas?.length > 0">

                    <h6 class="text-center mb-4 main_color label_lg_bold">
                        اجمالي عدد الفيلات
                        <span class="color_black"> ( {{AdvertisementData?.villas?.length}} ) </span>
                    </h6>

                    <ul class="list_none tabs text-center" >
                        <ng-container *ngFor="let villa of AdvertisementData?.villas">
                            <li 
                                [routerLink]="['../', villa?.id]"
                                [ngClass]="{
                                    'sold': villa?.status == STATUS_TYPE.COM,
                                    'booking': villa?.status == STATUS_TYPE.booking,
                                    'available': villa?.status == STATUS_TYPE.N || villa?.status == STATUS_TYPE.Started || villa?.status == STATUS_TYPE.PR
                                }"                                            
                                class="d-inline-flex align-items-center justify-content-center border_r label_lg_normal pointer text-center"
                            >
                                <span>رقم الفيلا</span>
                                ( {{villa?.unitNumber || villa?.id}} )
                            </li>                                                        
                        </ng-container>
                    </ul>
                </ng-container>
            </div>
        </div>
    </div>
    <!-- // end bundled_ads -->

    <!-- // start imgs3d -->
    <div class="imgs_3d">
        <div class="container">
            <ng-container *ngIf="AdvertisementData?.link3D?.length">
                <h6 class="text-center mt-4 main_color label_lg_bold">
                    محتوى الصورة 360 درجه  
                </h6>  

                <iframe 
                    width="100%"
                    loading="lazy"
                    height="550px"
                    title="عرض المخطط"
                    allowFullscreen="true"
                    [src]="AdvertisementData?.link3D[0] | safeUrl: URL_TYPE.resourceURL"
                >
                </iframe>
            </ng-container>
        </div>
    </div>

    <!-- start related-advertisements -->
    <app-related-advertisements [advertisementData]="AdvertisementData" />
    <!-- end related-advertisements --> 

</div>